/* eslint-disable */
export default {
  tollFree: 'Gratuito',
  rcvPmiMeetingTitle: 'Videoconferência de {extensionName}',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
